module.exports = __webpack_public_path__ + "img/201603-2-576x1024.c6b5af26.jpg";